export interface IPaginationElement {
    id: number;
}

interface IPaginationElementClassBuilder<T> {
    new(): T;
    toModel(json: string): T;
}

export class IPagination<T> {
    totalResults: number;
    dataList: T[];

    static toModel<T extends IPaginationElement>(json: string, viewClass: IPaginationElementClassBuilder<T>): IPagination<IPaginationElement> {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }

        const toReturn = new IPagination<IPaginationElement>();
        toReturn.totalResults = data.TotalResults;
        toReturn.dataList = data.DataList ? data.DataList.map(singleData => viewClass.toModel(JSON.stringify(singleData)))
                                        : null;
        return toReturn;
    }
}
